export default function AppsClosed({ year, message }) {
	return (
		<div className="mt-12  rounded-md mx-4 border" data-sentry-component="AppsClosed" data-sentry-source-file="index.jsx">
			<div className="bg-yellow-200 rounded-t-md w-full h-2" />
			<h2 className="text-center text-2xl py-8 px-2">
				Applications are closed for the {year} Elf Fund.
			</h2>
			<p className="text-center text-lg px-2 pb-8 max-w-2xl mx-auto whitespace-pre-line">
				{message}
			</p>
		</div>
	);
}
